// Урон по Герою с учётом А.4.4.2+3:
//   - Иммунитет (после Парашюта) — урон 0.
//   - Секретарь — перенаправляет урон на себя (passive).
//   - Парашют — если урон смертельный, hp=1, Иммунитет до конца хода.
//
// Используется во всех местах, где Герой может получить урон:
//   - авто-атака unitVsHero в Ф3
//   - heroVsHero в Ф4/5
//   - активация стелс-юнита по Герою
//   - Манипуляция фондовым рынком
//   - Vzlom (если цель — Герой; в нашей реализации Vzlom бьёт только юнита, но helper универсален)

import { applyDamage } from './combat.js';
import { shortHeroName } from '../data/heroes.js';
// Б.2.c: уведомление триггера «союзный персонаж получил урон» (Тёмный нетраннер).
import { notifyCharacterDamaged } from './abilities/syntetics/temnyy-netranner.js';

const SEKRETAR_ID = 'deus_sekretar';

// Найти Секретаря на стороне обороняющегося. Первый слева на 1-й линии, потом на 2-й.
export function findSekretar(player) {
  for (let line = 0; line < 2; line++) {
    for (let slot = 0; slot < 4; slot++) {
      const u = player.field[line][slot];
      if (u && u.isAlive() && u.id === SEKRETAR_ID) return u;
    }
  }
  return null;
}

// Перенаправить цель на Секретаря, если оборонцу нужен сей перенос.
// target — Card. Возвращает {target, redirectedToSekretar}.
export function redirectToSekretar(player, target) {
  if (!target || target.type !== 'hero') return { target, redirectedToSekretar: false };
  const sek = findSekretar(player);
  if (!sek) return { target, redirectedToSekretar: false };
  return { target: sek, redirectedToSekretar: true };
}

// Применить урон по Герою. opts: { pierce, sourceLabel }.
// Возвращает {dmg, hpLost, armorAbsorbed, ignoredArmor, immune, parachute, hero}.
export function applyHeroDamage(state, defenderIdx, dmg, opts = {}) {
  const player = state.players[defenderIdx];
  const hero = player.hero;
  if (dmg <= 0) {
    return { dmg: 0, hpLost: 0, armorAbsorbed: 0, ignoredArmor: 0, immune: false, parachute: false, hero };
  }
  // Иммунитет.
  if (player.heroImmuneUntilTurn != null && state.currentTurn <= player.heroImmuneUntilTurn) {
    state.log.add(`🛡 ${shortHeroName(hero)} [${player.name}]: Иммунитет — ${dmg} урона блокированы`);
    return { dmg: 0, hpLost: 0, armorAbsorbed: 0, ignoredArmor: 0, immune: true, parachute: false, hero };
  }
  // Снимок до удара.
  const beforeArmor = hero.armor;
  // В.2.g: пробрасываем state в applyDamage — нужно для on_damage_taken
  // триггера Бессмертного (он сидит на Герое и реагирует на damageToHp).
  const r = applyDamage(hero, dmg, { pierce: opts.pierce, state, source: opts.sourceLabel });
  // Парашют — если стало смертельно.
  if (hero.hp <= 0 && player.parachuteActive) {
    hero.hp = 1;
    hero.armor = beforeArmor;       // восстановим броню (урон откатывается)
    player.parachuteActive = false;
    player.heroImmuneUntilTurn = state.currentTurn;
    state.log.add(`🪂 Золотой парашют [${player.name}]: смертельный удар отменён, ${shortHeroName(hero)} HP=1, Иммунитет до конца хода`);
    return { dmg: 0, hpLost: 0, armorAbsorbed: 0, ignoredArmor: 0, immune: false, parachute: true, hero };
  }
  // Б.2.c: фактический taken — для нетраннер-триггера.
  const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
  if (taken > 0) notifyCharacterDamaged(state, defenderIdx, hero, taken);
  return { ...r, dmg, immune: false, parachute: false, hero };
}
